import {Vendor} from "./vendor";
import {Feature} from "./feature";
import {SpecialFeature} from "./special-feature";
import {SpecialPurpose} from "./special-purpose";
import {LIPurpose} from "./l-i-purpose";
import {IVendor as IGVLVendorInfo} from "./vendor-list";
import cmp from "../context/context";
import {DataCategory} from "./data-category";

class VendorLI extends Vendor {

    /* STATIC */
    public static override build(vendorId:number): VendorLI|null {
        const gvlVendor: IGVLVendorInfo|null|undefined = cmp().vendorList?.getVendorInfo(vendorId);
        if (gvlVendor) {
            return new VendorLI(gvlVendor);
        }
        return null;
    }

    /* INSTANCE */
    public override get purposes(): LIPurpose[] {
        const purposes: LIPurpose[] = [];
        this._gvlVendor.legIntPurposes.forEach((purposeId:number) => {
            const purpose:LIPurpose|null = LIPurpose.build(purposeId);
            if (purpose) {
                purposes.push(purpose);
            }
        });
        return purposes;
    }

    public override get features(): Feature[] {
        return [];
    }

    public override get specialFeatures(): SpecialFeature[] {
        return [];
    }

    public override get specialPurposes(): SpecialPurpose[] {
        return [];
    }

    public override get dataCategories(): DataCategory[] {
        return [];
    }

    public override get accepted(): boolean|undefined {
        return cmp().tcString?.vendorsLI[this.id];
    }

}

export {VendorLI}
